import { Button } from '@razz-team/ui-web';
import { useCardActivateMutation } from '../../../api/cards';
import { ApiCard } from '../../../openapi';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export function isActivatable(card: ApiCard) {
  return card.status === 'ISSUED';
}

export function ActivateCardButton({ card }: { card: ApiCard }) {
  const { t } = useTranslation();
  const mutation = useCardActivateMutation(card.id);

  const handleClick = useCallback(() => mutation.mutate({}), [mutation]);

  return (
    <Button color="primary" size="large" loading={mutation.isPending} onClick={handleClick}>
      {t('Activate')}
    </Button>
  );
}
